import { InboxOutlined } from "@ant-design/icons";
import type { IntlShape } from "@formatjs/intl";
import type { Dispatch } from "@reduxjs/toolkit";
import { Upload } from "antd";
import { useSelector } from "react-redux";
import type { RootState } from "../../store";
import { startViewUpload } from "../../files/store";

type Props = {
  intl: IntlShape;
  dispatch: Dispatch;
  ticketId: string;
};

export const TicketFileDropzone = ({ intl, dispatch, ticketId }: Props) => {
  const messageApi = useSelector((state: RootState) => state.appFeedback.message);

  return (
    <Upload.Dragger
      multiple
      action={undefined}
      showUploadList={false}
      customRequest={(options) => {
        if (options.file instanceof File) {
          const hide = messageApi?.loading(
            intl.formatMessage({ id: "upload_uploading" }),
            0
          );
          dispatch(
            startViewUpload({
              file: options.file,
              ticketId,
              onSuccess: () => {
                hide?.();
                messageApi?.success(intl.formatMessage({ id: "upload_success" }));
              },
              onError: () => {
                hide?.();
                messageApi?.error(intl.formatMessage({ id: "upload_failed" }));
              },
            })
          );
        }
      }}
    >
      <p className="ant-upload-drag-icon">
        <InboxOutlined />
      </p>
      <p className="ant-upload-text">{intl.formatMessage({ id: "upload_choose_files" })}</p>
      <p className="ant-upload-hint">{intl.formatMessage({ id: "upload_hint" })}</p>
    </Upload.Dragger>
  );
};
